import React, {useContext} from "react";
import {Link, useHistory} from "react-router-dom";
import styled from "styled-components";
import {ResetButton} from "../../../styles/Button";
import {ReactComponent as MenuIcon} from "../../../assets/icons/open-menu.svg";
import {ReactComponent as UserIcon} from "../../../assets/icons/user.svg";
import {GlobalContext} from "../../../context/GlobalContext";
import Color from "../../../assets/Colors";

export default function MobileNav({logoInvert, classname}) {
   const {setMenu} = useContext(GlobalContext);
   let history = useHistory();

   return (
      <Nav>
         <Link className="logo" to="/">
            {!logoInvert ? (
               <img src={require("../../../assets/logo/domecq_academy_white.png")} alt="domecq" />
            ) : (
               <img src={require("../../../assets/logo/domecq_academy.png")} alt="domecq" />
            )}
         </Link>

         <div className="second">
            <ButtonAction className={classname} onClick={() => history.push("/iniciar_sesion")}>
               <UserIcon width="1.3em" height="1.3em" className="icon" />
            </ButtonAction>
            <ButtonAction className={classname} onClick={() => setMenu(true)}>
               <MenuIcon width="2em" height="1.3em" className="icon" />
            </ButtonAction>
         </div>
      </Nav>
   );
}

MobileNav.defaultProps = {
   logoInvert: false,
};

const Nav = styled.nav`
   width: 100%;
   display: flex;
   justify-content: space-between;
   align-items: center;

   & .second {
      display: flex;
      align-items: center;

      & button {
         padding: 0 0.3em;
         margin-bottom: -20px;

         &:first-child {
            margin-right: 0.5em;
         }
      }
   }

   & .logo {
      display: block;
      width: 100px;
      // margin-left: -15px;

      & img {
         width: 100%;
      }
   }
`;

const ButtonLink = styled(Link)`
   color: white;
   display: block;

   & .icon {
      fill: white;
   }

   &.invert {
      & .icon {
         fill: ${Color.primary};
      }
   }
`;

const ButtonAction = styled(ResetButton)`
   color: white;
   & .icon {
      fill: white;
   }

   &.invert {
      & .icon {
         fill: ${Color.primary};
      }
   }
`;
